function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getOwner } from '@ember/application';
import Service from '@ember/service';
import environment from '@square/environment-utils/environment';
export default class EmberMultipassConfigService extends Service {
  constructor(properties) {
    super(properties);
    _defineProperty(this, "environment", void 0);
    const env = getOwner(this).lookup('environment:current') || environment();
    this.environment = env.name;
  }
  get isProduction() {
    return this.environment === 'production';
  }
  get isStaging() {
    return this.environment === 'staging';
  }
}